import { handleActions } from "redux-actions";
import { fetchActions, IFetchStoreState, initialFetchState } from "./base-reducers";
import { IMerchant } from "containers/management/management-types";
import { UTILITIES } from "constants/action-types";

export type IMerchantState = IFetchStoreState<IMerchant[]>;

export const merchants = handleActions<IMerchantState>(
    {
        ...fetchActions(UTILITIES.MERCHANTS.FETCH),
    } as any,
    initialFetchState,
);
